module.exports = __webpack_public_path__ + "media/images/logo-blue-with-name-284c9ddf72852a0b0c7784803dd20d2c.png";